/* KleitasTev custom enhancements */
(function () {
  const MOBILE_MAX = 740;
  const STYLE_ID = 'kt-mobile-card-swipe-style';

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      @media (max-width: ${MOBILE_MAX}px) {
        .product-item__aspect-ratio.kt-swipe-ready > .product-item__primary-image,
        .product-item__aspect-ratio.kt-swipe-ready > .product-item__secondary-image { display:none !important; }
        .kt-card-swipe { position:absolute; inset:0; display:flex; overflow-x:auto; overflow-y:hidden; scroll-snap-type:x mandatory; scrollbar-width:none; -webkit-overflow-scrolling:touch; z-index:1; }
        .kt-card-swipe::-webkit-scrollbar { display:none; }
        .kt-card-swipe__slide { flex:0 0 100%; width:100%; height:100%; scroll-snap-align:start; scroll-snap-stop:always; position:relative; }
        .kt-card-swipe__slide img { width:100%; height:100%; display:block; object-fit:cover; }
        .kt-card-swipe__dots { position:absolute; left:50%; bottom:8px; transform:translateX(-50%); display:flex; gap:5px; z-index:3; pointer-events:none; padding:4px 6px; border-radius:20px; background:rgba(255,255,255,.62); }
        .kt-card-swipe__dot { width:5px; height:5px; border-radius:50%; background:rgba(0,0,0,.28); transition:transform .18s ease, background .18s ease; }
        .kt-card-swipe__dot.is-active { background:rgba(0,0,0,.78); transform:scale(1.25); }
        .product-item-meta__title { display:-webkit-box !important; -webkit-box-orient:vertical; -webkit-line-clamp:2; overflow:hidden; }

        /* Keep the app's original promo layout, only scale it down on mobile. */
        body > div:has([class*="countdown" i]),
        body > div:has([id*="countdown" i]),
        body > div:has([class*="timer" i]),
        body > div:has([id*="timer" i]) {
          max-height: 82px !important;
          min-height: 0 !important;
        }
        [class*="countdown" i] h1, [class*="countdown" i] h2, [class*="countdown" i] h3,
        [id*="countdown" i] h1, [id*="countdown" i] h2, [id*="countdown" i] h3,
        [class*="timer" i] h1, [class*="timer" i] h2, [class*="timer" i] h3,
        [id*="timer" i] h1, [id*="timer" i] h2, [id*="timer" i] h3 {
          font-size: 14px !important;
          line-height: 1.05 !important;
          font-weight: 600 !important;
          margin: 0 0 2px !important;
          white-space: nowrap !important;
        }
        [class*="countdown" i] p, [id*="countdown" i] p,
        [class*="timer" i] p, [id*="timer" i] p {
          font-size: 11px !important;
          line-height: 1.05 !important;
          margin: 0 0 2px !important;
        }
        [class*="countdown" i] [class*="time" i], [class*="countdown" i] [class*="number" i], [class*="countdown" i] [class*="digit" i],
        [id*="countdown" i] [class*="time" i], [id*="countdown" i] [class*="number" i], [id*="countdown" i] [class*="digit" i],
        [class*="timer" i] [class*="time" i], [class*="timer" i] [class*="number" i], [class*="timer" i] [class*="digit" i],
        [id*="timer" i] [class*="time" i], [id*="timer" i] [class*="number" i], [id*="timer" i] [class*="digit" i] {
          font-size: 18px !important;
          line-height: 1 !important;
        }
        [class*="countdown" i] [class*="label" i], [id*="countdown" i] [class*="label" i],
        [class*="timer" i] [class*="label" i], [id*="timer" i] [class*="label" i] {
          display: initial !important;
          font-size: 8px !important;
          line-height: 1 !important;
        }
        [class*="countdown" i] button, [class*="countdown" i] a,
        [id*="countdown" i] button, [id*="countdown" i] a,
        [class*="timer" i] button, [class*="timer" i] a,
        [id*="timer" i] button, [id*="timer" i] a {
          min-height: 30px !important;
          padding: 5px 10px !important;
          font-size: 11px !important;
          line-height: 1 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          text-align: center !important;
        }
      }
      @media (min-width: ${MOBILE_MAX + 1}px) { .kt-card-swipe, .kt-card-swipe__dots { display:none !important; } }
    `;
    document.head.appendChild(style);
  }

  function productJsonUrl(href) { const u=new URL(href,window.location.origin); u.search=''; u.hash=''; if(!u.pathname.endsWith('.js')) u.pathname=u.pathname.replace(/\/$/,'')+'.js'; return u.toString(); }
  function sizedImage(url) { try { const u=new URL(url,window.location.origin); u.searchParams.set('width','700'); return u.toString(); } catch(e){ return url; } }
  async function enhanceCard(card) {
    if (window.innerWidth > MOBILE_MAX || card.dataset.ktSwipeInit) return; card.dataset.ktSwipeInit='1'; const link=card.querySelector('.product-item__aspect-ratio'); if(!link)return;
    try { const response=await fetch(productJsonUrl(link.href),{credentials:'same-origin'}); if(!response.ok)return; const product=await response.json(); const images=Array.isArray(product.images)?product.images.slice(0,3):[]; if(images.length<2)return;
      const track=document.createElement('div'); track.className='kt-card-swipe'; track.setAttribute('aria-label','Produkta attēli');
      images.forEach((src,index)=>{const slide=document.createElement('div');slide.className='kt-card-swipe__slide';const img=document.createElement('img');img.src=sizedImage(src);img.alt=product.title||'';img.loading=index===0?'eager':'lazy';img.decoding='async';slide.appendChild(img);track.appendChild(slide);});
      const dots=document.createElement('div');dots.className='kt-card-swipe__dots';images.forEach((_,index)=>{const dot=document.createElement('span');dot.className='kt-card-swipe__dot'+(index===0?' is-active':'');dots.appendChild(dot);});
      let startX=0,moved=false;track.addEventListener('touchstart',e=>{startX=e.touches[0].clientX;moved=false;},{passive:true});track.addEventListener('touchmove',e=>{if(Math.abs(e.touches[0].clientX-startX)>8)moved=true;},{passive:true});link.addEventListener('click',e=>{if(moved){e.preventDefault();e.stopPropagation();moved=false;}},true);
      let raf=0;track.addEventListener('scroll',()=>{cancelAnimationFrame(raf);raf=requestAnimationFrame(()=>{const index=Math.max(0,Math.min(images.length-1,Math.round(track.scrollLeft/Math.max(track.clientWidth,1))));dots.querySelectorAll('.kt-card-swipe__dot').forEach((dot,i)=>dot.classList.toggle('is-active',i===index));});},{passive:true});
      link.appendChild(track);link.appendChild(dots);link.classList.add('kt-swipe-ready');
    } catch(e){card.dataset.ktSwipeInit='';}
  }
  let observer; function scan(){if(window.innerWidth>MOBILE_MAX)return;addStyles();if(!observer){observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){observer.unobserve(entry.target);enhanceCard(entry.target);}});},{rootMargin:'350px 0px'});}document.querySelectorAll('product-item:not([data-kt-swipe-observed])').forEach(card=>{card.dataset.ktSwipeObserved='1';observer.observe(card);});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();const mo=new MutationObserver(()=>scan());mo.observe(document.documentElement,{childList:true,subtree:true});
})();
